import { 
    collection, 
    getDocs, 
    doc, 
    updateDoc, 
    deleteDoc, 
    setDoc, 
    serverTimestamp, 
    query,
    orderBy 
} from 'firebase/firestore';
import { 
    ref, 
    uploadBytes, 
    getDownloadURL,
    deleteObject 
} from 'firebase/storage';
import { initializeApp } from 'firebase/app'; 
import { createUserWithEmailAndPassword, getAuth, signOut } from 'firebase/auth';
import app, { db, storage } from '../config/firebase'; 

const COLLECTION_NAME = 'users';

/**
 * Obtiene todos los usuarios ordenados alfabéticamente.
 */
export const getAllUsers = async () => {
    // MEJORA: Agregamos orderBy para UX
    const q = query(collection(db, COLLECTION_NAME), orderBy('fullName'));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

/**
 * Crea un nuevo usuario.
 * MANTENEMOS TU LÓGICA: Es excelente usar app.options.
 */
export const createUser = async (email, password, userData) => {
    let secondaryApp = null;
    try {
        secondaryApp = initializeApp(app.options, 'Secondary');
        const secondaryAuth = getAuth(secondaryApp);

        const userCredential = await createUserWithEmailAndPassword(secondaryAuth, email, password);
        const newUser = userCredential.user;

        await signOut(secondaryAuth);

        await setDoc(doc(db, COLLECTION_NAME, newUser.uid), {
            email: email.toLowerCase(), // MEJORA: Normalizar email
            ...userData,
            uid: newUser.uid, // MEJORA: Redundancia útil para búsquedas
            createdAt: serverTimestamp(),
            status: 'active'
        });

        return newUser;
    } catch (error) {
        throw error;
    } finally {
        // Dejamos que GC limpie
    }
};

/**
 * Actualiza usuario.
 */
export const updateUser = async (userId, userData) => {
    const userRef = doc(db, COLLECTION_NAME, userId);
    await updateDoc(userRef, {
        ...userData,
        updatedAt: serverTimestamp()
    });
};

/**
 * Elimina usuario de Firestore.
 */
export const deleteUser = async (userId) => {
    await deleteDoc(doc(db, COLLECTION_NAME, userId));
};

/**
 * Sube documento.
 * MEJORA: Guardamos el 'fullPath' para poder borrarlo después.
 */
export const uploadUserDocument = async (userId, file, currentDocuments) => {
    // Usamos timestamp para evitar colisiones de nombre
    const fileRef = ref(storage, `user-docs/${userId}/${Date.now()}_${file.name}`);
    
    const snapshot = await uploadBytes(fileRef, file);
    const url = await getDownloadURL(fileRef);

    const newDoc = {
        name: file.name,
        url: url,
        path: snapshot.ref.fullPath, // <--- ESTO ES CLAVE PARA BORRARLO LUEGO
        uploadedAt: new Date().toISOString(),
        type: file.type
    };

    const updatedDocs = [...currentDocuments, newDoc];
    
    await updateDoc(doc(db, COLLECTION_NAME, userId), { documents: updatedDocs });
    
    return updatedDocs;
};

/**
 * Elimina documento de BD y Storage.
 * MEJORA: Recibe el objeto documento para borrar el archivo físico.
 */
export const deleteUserDocumentReference = async (userId, updatedDocsList, docToDelete) => {
    // 1. Intentar borrar el archivo físico si tiene path
    if (docToDelete && docToDelete.path) {
        try {
            const fileRef = ref(storage, docToDelete.path);
            await deleteObject(fileRef);
        } catch (error) {
            console.warn("No se pudo borrar el archivo físico (quizás ya no existe):", error);
            // No bloqueamos el flujo si falla el borrado físico, priorizamos limpiar la BD
        }
    }

    // 2. Actualizar la lista en base de datos
    await updateDoc(doc(db, COLLECTION_NAME, userId), { documents: updatedDocsList });
};